module.exports = __webpack_public_path__ + "img/not-found-img.417cd634.svg";